import { useRef, useEffect, useState } from 'react';
import './reset.css';
import './App.css';
import inquiryIcon from './images/inquiry_ico.png';
import mainVisual from "./video/main_visual.mp4"
import scrollIcon from "./images/scroll_down_ico.png"

import Sec01 from './components/Sec01';
import Sec02 from './components/Sec02';
import Sec03 from './components/Sec03';
import Sec04 from './components/Sec04';
import Sec05 from './components/Sec05';

function App() {

    const sec02Ref = useRef(null);
    const sec03Ref = useRef(null);

    const goToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        })
    }

    const goToSec02 = () => {
        window.scrollTo({
            top: sec02Ref.current.offsetTop,
            behavior: 'smooth',
        })
    }

    const goToSec03 = () => {
        window.scrollTo({
            top: sec03Ref.current.offsetTop,
            behavior: 'smooth',
        })
    }

    const mainVisualRef = useRef(null);
    const [isScrolled, setIsScrolled] = useState(false);
    useEffect(() => {

        const handleScroll = () => {
            if (!mainVisualRef.current) return;
            const mainVisualTop = mainVisualRef.current.offsetTop;
            const mainVisualHeight = mainVisualRef.current.offsetHeight;
            const scrollY = window.scrollY;
            if (scrollY > mainVisualTop + mainVisualHeight) {
                setIsScrolled(true);
            } else {
                setIsScrolled(false);
            }
        };

        window.addEventListener('scroll', handleScroll);

        return () => window.removeEventListener('scroll', handleScroll);

    }, []);

    return (
        <div className="App">
            <header className={`header ${isScrolled ? 'scrolled' : ''}`}>
                <h1 onClick={() => { goToTop(); }}>PUFFU CHEMICAL</h1>
                <ul>
                    <li className='m_hide' onClick={() => { goToSec02(); }} >
                        <p>회사소개</p>
                    </li>
                    <li className='m_hide' onClick={() => { goToSec03(); }}>
                        <p>주요사업</p>
                    </li>
                    <li className='inquiry_btn' onClick={() => window.open('https://www.worldintl.co.kr/support/contactUs', '_blank')}>
                        <p>사업문의</p>
                        <div className='ico_box'>
                            <img src={inquiryIcon} alt='사업문의로 이동' />
                        </div>
                    </li>
                </ul>
            </header>
            <div className='main_visual' ref={mainVisualRef}>
                <div className='video_box'>
                    <video src={mainVisual} autoPlay muted loop playsInline />
                    <div className='overlay'></div>
                </div>
                <div className='content_box'>
                    <div className='txt_box'>
                        <h2>
                            공정은 철저하게 품질은 완벽하게
                        </h2>
                        <p>
                            체계적인 생산 시스템과 설비를 기반으로 <br />
                            제품의 품질을 보장하는 국내 최대 규모의 전자담배 액상 제조업체
                        </p>
                    </div>
                    <div className='scroll_box'>
                        <p>SCROLL DOWN</p>
                        <div className='ico_box'>
                            <img src={scrollIcon} alt='스크롤 다운' />
                        </div>
                    </div>
                </div>
            </div>
            <Sec01 />
            <Sec02 sec02Ref={sec02Ref} />
            <Sec03 sec03Ref={sec03Ref} />
            <Sec04 />
            <Sec05 />
            <div className='inquiry_banner'>
                <p className='main_txt'>비즈니스 파트너십,<br className='br_m' /> 지금 문의하세요</p>
                <p className='sub_txt'>OEM·ODM 협업부터 제품 상담까지<br className='br_m' /> 언제든 열려 있습니다.</p>
                <button onClick={() => window.open('https://www.worldintl.co.kr/support/contactUs', '_blank')}>
                    지금 바로 사업 문의하기
                </button>
            </div>
            <footer>
                <div className='crop_info'>
                    <p>
                        <strong>대표</strong>
                        이태우
                    </p>
                    <p>
                        <strong>주소</strong>
                        대전광역시 서구 관저중로95번길 68, 3층(관저동)
                    </p>
                </div>
                <div className='copyright'>
                    <p>© PUFFU CHEMICAL ALL RIGHTS RESERVED.</p>
                </div>
            </footer>
        </div>
    );
}

export default App;
